import { APIClient } from "@heidelbergmaterials/fcl-apiclient"
import { useAuthentication } from "@heidelbergmaterials/fcl-authclient"

import { useBaseApiClient } from "./useBaseApiClient"

export const authApiUrl = import.meta.env.VITE_AUTH_API

/**
 * Custom hook to get Auth API client with authentication token
 *
 * This hook creates an APIClient instance configured for the Auth API (VITE_AUTH_API)
 * with token interceptor that adds the FCP access token to requests.
 *
 * @returns APIClient instance configured for Auth API with token interceptor
 *
 * @example
 * ```tsx
 * import { useAuthApiClient } from '@shared/api/client/useAuthApiClient'
 *
 * const MyComponent = () => {
 *   const authClient = useAuthApiClient()
 *
 *   const fetchUserProfile = async (userId: string) => {
 *     const response = await authClient.get(`/users/${userId}`)
 *     return response.data
 *   }
 * }
 * ```
 */
export const useAuthApiClient = (): APIClient => {
	const { authFlow } = useAuthentication()

	return useBaseApiClient({
		baseURL: authApiUrl,
		authFlow,
		useInterceptors: true,
	})
}
